import styled from 'styled-components'

export const FieldInput = styled.input`
    padding: 11px 12px;
    border: 1px solid #cfd9ea;
    border-radius: 12px;
    background: #f8fbff;
    color: #2f4c7d;
    font-size: 15px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:focus {
        border-color: #4a6fb0;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(74, 111, 176, 0.15);
    }

    &[type='checkbox'] {
        width: 22px;
        height: 22px;
        accent-color: #4a6fb0;
    }
`

export const FieldSelect = styled.select`
    padding: 11px 12px;
    border: 1px solid #cfd9ea;
    border-radius: 12px;
    background: #f8fbff;
    color: #2f4c7d;
    font-size: 15px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:focus {
        border-color: #4a6fb0;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(74, 111, 176, 0.15);
    }
`

export const FieldLabel = styled.label`
    display: flex;
    flex-direction: column;
    gap: 7px;
    font-size: 14px;
    font-weight: 600;
    color: #39598a;
`

export const FieldLabelText = styled.span``
